module.exports = __webpack_public_path__ + "img/receipt35.bc7a279f.svg";